import { render, staticRenderFns } from "./bumdes.vue?vue&type=template&id=54c8bea0&"
import script from "./bumdes.vue?vue&type=script&lang=js&"
export * from "./bumdes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBtnGroup,QBtn,QInput,QIcon,QPagination,QDialog,QCard,QCardSection,QTooltip,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBtnGroup,QBtn,QInput,QIcon,QPagination,QDialog,QCard,QCardSection,QTooltip,QCardActions})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
